import { useLazyQuery, useMutation } from '@apollo/client';
import { useCallback, useEffect, useState } from 'react';
import { Input, Label, Table } from 'reactstrap';
import { CategoryType, OrgOrgRelType } from '../../../../types/constants';
import { GET_CHILD_ORGS, GET_ORG_RELATIONSHIPS, GET_ROOT_ORGS, REMOVE_OTHER_ORGS } from '../../../../graphql/org-gql';
import { LOCALES } from '../../../../i18n/locales';
import { messages } from '../../../../i18n/message';
import { notifySuccess } from '../../../../services/notification';
import { IOrg, IOrgRelationship, IOrgResponse } from '../../../../types/org';
import DateFormat from '../../../common/date-format';
import {  DeleteIcon, MoveIcon } from '../../../common/icons';
import SpinnerOverlay from '../../../common/spinner/spinner';
import "../../org-info.scss";
import RelationshipMoveModal from './relationship-move';
import OmsToolTip from '../../../common/oms-tooltip/oms-tooltip';
import useAuth from '../../../../hook/useAuth';
import { Action } from '../../../../types/individual';
import confirm from "../../../common/confirm";
import Button from '../../../common/button';
interface RelatedOrganizationsProps {
    org: IOrg;
}

const Relationship = (props: RelatedOrganizationsProps) => {
    const {org} = props;
    const [checked, setChecked] = useState<{ [key: string]: boolean }>({});
    const [checkedAll, setCheckedAll] = useState<boolean>( false);
    const [orgMoveOpen, setOrgMoveOpen] = useState<boolean>(false)
    const [orgRelationshipRemoveOpen,setOrgRelationshipRemoveOpen] =useState<boolean>(false);
    const [selectedRelationships,setSelectedRelationships] = useState<IOrgRelationship[]>([]);
    const [checkedCount,setCheckedCount] = useState<number>(0);
    const [removable,setRemovable] = useState<boolean>(false);
    const [movable,setMovable] = useState<boolean>(false);
    const [totalCheckboxes,setTotalCheckboxes] =useState<number|undefined>(undefined);
    const toggleOrgMove = useCallback(() => {setOrgMoveOpen(!orgMoveOpen)}, [orgMoveOpen])
    const toggleOtherOrgsRemove = useCallback(() => {setOrgRelationshipRemoveOpen(!orgRelationshipRemoveOpen)}, [orgRelationshipRemoveOpen])
    const [orgRelationships,{loading: relationshipLoading, data: relationshipData}]= useLazyQuery<IOrgResponse>(GET_ORG_RELATIONSHIPS);
    const { isFrenchTranslator } = useAuth()
    const [cloned,setCloned] = useState<boolean>(false);

    useEffect(() => {
        //console.log("org:",org)
        setCloned(!!org.details?.shareLinkId)
        orgRelationships({variables: {orgId:org.id}});
        return(()=>{
            setChecked({});
            setCheckedAll(false);
            setCheckedCount(0);
            setMovable(false)
            setRemovable(false)
        })
    }, [org])

    useEffect(() => {

        //console.log('relationshipData:',relationshipData)
        setTotalCheckboxes(relationshipData?.org?.relationships?.length)

    }, [relationshipData])

    useEffect(() => {

        const checkedRelationships = relationshipData?.org?.relationships?.filter(relationship=>{
            return checked[relationship.relationshipId]
        })
        const count = checkedRelationships?.length||0;
        setCheckedCount(count);
        if(count&&totalCheckboxes&&count===totalCheckboxes&&count!==0) setCheckedAll(true);
        else setCheckedAll(false)
        setSelectedRelationships(checkedRelationships||[]);
        const hasDirect = (checkedRelationships ?? []).filter(rl => rl.relationshipType.code === OrgOrgRelType[0]).length > 0;
        setRemovable(count!==0&&!hasDirect);
        const hasNotDirect = (checkedRelationships ?? []).filter(rl => rl.relationshipType.code !== OrgOrgRelType[0]).length > 0;
        setMovable(count!==0&&count!==undefined&&!hasNotDirect)
    }, [checked,totalCheckboxes,relationshipData]);

    const onSelectAllChange=()=>{
        const updatedChecked:any = {};

        relationshipData?.org?.relationships?.forEach(relationship=>{
            updatedChecked[relationship.relationshipId] = !checkedAll;
        })
        setChecked(updatedChecked);
        setCheckedAll(!checkedAll);
    }
    const onSelectedChange = (index: number) => {
        setChecked((previousChecked) => ({
          ...previousChecked,
          [index]: !previousChecked[index],
        }));
      };

    const [removeOtherOrgs, {loading: loadingRemove}] = useMutation(REMOVE_OTHER_ORGS);

    const removeOtherOrgsExecute=()=>{
        const orgRelationshipIds = selectedRelationships.map(rel=>rel.relationshipId)
        removeOtherOrgs({
            variables: {
                orgId:org?.id||0,
                action: Action.REMOVE_RELATIONSHIP,
                input: {orgId:org?.id||0,relationshipIds:orgRelationshipIds}
            },
            refetchQueries: getRefetchQuery(),
            awaitRefetchQueries: true,
            //update(cache,{data}){updateCache(cache,data,org.id,selectedRelationships)},
            onCompleted: (data) => {

                toggleOtherOrgsRemove()
                setChecked({});
                setCheckedAll(false);
                setCheckedCount(0);
                data?.removeOtherOrgs?.success && notifySuccess()
            }
        })
    }

    /*const updateCache = (cache : ApolloCache <any>, result: any,orgId:number,relationships:IOrgRelationship[]) => {

        console.log("selectedRelationships:",selectedRelationships)

        const cachedChildren = cache.readQuery<{childOrgs:IOrg[]}>({
            query:GET_CHILD_ORGS,
            variables:{id:orgId}
        })?.childOrgs;

        if(cachedChildren&&cachedChildren.length===1){
            // update hasChild for toOrg
            cache.modify({
                id: `Org:${orgId}`,
                fields: {
                    hasChild() {
                        return false;
                    }
                }
            })
        }     
    }*/

    const getRefetchQuery = () => {
        let query:any
        if (org.id) {
            query = [{query: GET_ORG_RELATIONSHIPS, variables: { orgId: org.id }},{query:GET_CHILD_ORGS,variables:{id:org.id}}]
        }
        if(selectedRelationships&&selectedRelationships.length>0){
            selectedRelationships.forEach(rel=>{
                if(rel.relationshipType.code==='SHARE'){
                    query = [...query,{query: GET_ORG_RELATIONSHIPS, variables: { orgId: rel.destOrgId }},{query:GET_CHILD_ORGS,variables:{id:rel.destOrgId}},{query:GET_CHILD_ORGS,variables:{id:rel.destParentOrgId}}]
                }
            })
        }
        if(org.parentOrg){
            query = [...query,{query:GET_CHILD_ORGS,variables:{id:org.parentOrg?.id}}]
        }else if(org.details?.category){
            query = [...query,{query:GET_ROOT_ORGS,variables:{categoryId:org.details?.category?.id}}]
        }
        return query;
    }

    const onRemove = () => {
        confirm({
            title: 'Remove Organization Relationship?',
            content: 'The selected organization relationship will be removed. <br/>Are you sure you want to continue?',
            okText: <><DeleteIcon/> Remove</>,
            okBtnColor: 'danger'
        }).then(() => {
            removeOtherOrgsExecute();
        })
    }

    return (
        <>
            {
                <RelationshipMoveModal parentOrg={org} isOpen={orgMoveOpen} toggle={toggleOrgMove} relationships={selectedRelationships||[]}></RelationshipMoveModal>
            }
            {(relationshipLoading || loadingRemove) && <SpinnerOverlay />}
            {(relationshipData && relationshipData.org?.relationships?.length === 0 ) && <span role="region" aria-label='No records found'>{messages[LOCALES.ENGLISH].INFO['1.2']}</span>}
            {
                ((relationshipData && relationshipData.org?.relationships?.length > 0 ) ) &&
                <>
                    {!isFrenchTranslator && org.details?.category?.type === CategoryType.ORGANIZATION && <Button color="primary" style={{ marginBottom: '15px',marginRight:'15px' }} onClick={toggleOrgMove} disabled={!movable||cloned}>
                        <MoveIcon/>
                        &nbsp;<span role="region" aria-label='Move'>Move</span>
                    </Button>
                    }

                    {!isFrenchTranslator && <Button color="danger" style={{ marginBottom: '15px',marginRight:'15px' }} onClick={onRemove} disabled={!removable||cloned}>
                        <DeleteIcon/>
                        &nbsp;<span role="region" aria-label='Remove'>Remove</span>
                    </Button>}

                    <Table striped className="organizations-table fixed" id="org_relationships">
                        <thead>
                            <tr>
                            {!isFrenchTranslator && <th className="icon-column">
                                    <Label for="selectAllCheckbox" role="region" aria-label='selectAllCheckbox' className='hidden-text'>selectAllCheckbox</Label>
                                    <Input id="selectAllCheckbox" aria-label="Select All" className="form-check-input" type='checkbox' onChange={() => onSelectAllChange()} checked={checkedAll||false} disabled={cloned}/>
                                </th>}
                                <th><span role="region" aria-label='Relationship'>Relationship</span></th>
                                <th><span role="region" aria-label='Organization'>Organization</span></th>
                                <th className="date-column date-column-mmm-dd-yyyy"><span role="region" aria-label='Start Date'>Start Date</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                relationshipData && relationshipData.org?.relationships?.length > 0 && relationshipData.org?.relationships?.map((relationship, index) => {
                                    return (
                                        <tr key={relationship.relationshipId}>
                                            {!isFrenchTranslator && <td>
                                                    <Label for={`checkboxNoLabel-${relationship.relationshipId}`} className='hidden-text' role="region" aria-label={relationship?.destOrgName}> {relationship?.destOrgName}</Label>
                                                    <Input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value={relationship.relationshipId}
                                                        id={`checkboxNoLabel-${relationship.relationshipId}`}
                                                        onChange={() => onSelectedChange(relationship.relationshipId)}
                                                        checked={checked[relationship.relationshipId] || false}
                                                        aria-label={`select ${relationship?.destOrgName}`}
                                                        disabled={cloned||relationship.destCloned}
                                                    />
                                            </td> }
                                            <td>
                                                {relationship?.relationshipType && (
                                                    <span role="region" aria-label='Relationship'>
                                                        {relationship.relationshipType.code==='DIRECT'?'Child':(relationship.positive?relationship.relationshipType.label:relationship.relationshipType.label2)}
                                                    </span>
                                                )}
                                            </td>
                                            <td>
                                                <OmsToolTip orgId={relationship?.destOrgId}>
                                                        {relationship?.destOrgName }
                                                </OmsToolTip>
                                            </td>
                                            <td><span role="region" aria-label='Start date'><DateFormat date={relationship?.createTimestamp} defaultText="No Date" /></span></td>
                                        </tr>
                                    )
                                })
                            }

                        </tbody>
                    </Table>
                </>
            }
        </>
    )
}

export default Relationship;
